import { ErrorPage } from "./ErrorPage";

export const NotFoundPage = () => <ErrorPage message="Siden kunne ikke findes" />;
